import * as React from "react";
import {
    Table
} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {useLayoutEffect} from "react";
import {getExpertData} from "../../../actions";
import TextAnswer from "./TextAnswer";
import FileAnswer from "./FileAnswer";
import SendAnswer from "./SendAnswer";

const GridCandidateRequestExpertField = ({
     schema: {
         id,
         visible
     }
}) => {
    // @ts-ignore
    const [form_type, process_id, votesResult] = useSelector((state: any) => [
        state.forms.form_type,
        state.forms.process_id,
        state.forms.votesResult
    ]);
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        // @ts-ignore
        getExpertData(form_type, process_id)(dispatch);
    }, []);

    return <div
        id={id}
        className="form-group"
    >
        <div
            className="col-xs-12 fullwidth"
        >
            <label className="control-label">
                <div className="reportbox-content-desc">
                    <span className={id}>
                        Вопросы экспертов
                    </span>
                </div>
            </label>
        </div>
        <div className="col-xs-12">
            {/* @ts-ignore */}
            <Table responsive>
                <thead>
                    <tr>
                        <th style={{paddingLeft: 0}}>Вопрос эксперта</th>
                        <th>Ответ</th>
                        <th>Приложение</th>
                        <th>Операции</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        votesResult?.length ? votesResult.map((item) => (
                            <tr>
                                <td style={{paddingLeft: 0}}>{item.question}</td>
                                <td>
                                    <TextAnswer item={item}/>
                                </td>
                                <td>
                                    <FileAnswer item={item}/>
                                </td>
                                <td>
                                    <SendAnswer item={item}/>
                                </td>
                            </tr>
                        )) : <tr>
                            <td style={{paddingLeft: 0, textAlign: 'center'}} colSpan={4}>Вопросов нет</td>
                        </tr>
                    }
                </tbody>
            </Table>
        </div>
    </div>;
}

export function createGridCandidateRequestExpertField(
    schema: any,
    // TODO: abstract type any
    api: any,
    dispatcher: any,
    error: any,
    visited: boolean,
    // TODO: abstract type any
    opts: any,
    // TODO: abstract type any
    information: any,
    values: Array<{ controlid: string; value: unknown }>,
    rowIndex: number
): React.ReactElement<any> {
    return (
        <GridCandidateRequestExpertField
            schema={schema}
        />
    );
}